import {
  AssessmentFieldSchema,
  ReturnAssessmentWithDefinitionSchema,
} from "@redotech/redo-return-core-common/return-assessments/assessment-schemas";
import { ReturnTypeEnum } from "@redotech/redo-return-core-common/return-type-enum";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const updateAssessment = {
  name: "updateAssessment" as const,

  input: z.object({
    assessmentId: zExt.objectId(),
    name: z.string().optional(),
    kind: createEnum(ReturnTypeEnum).optional(),
    fields: z.array(AssessmentFieldSchema),
    iconName: z.string().optional(),
    iconColor: z.string().optional(),
  }),

  output: ReturnAssessmentWithDefinitionSchema.nullable(),
};
